import _ from 'lodash';
import { RoleResponse } from '../api/queries.schemas';
import { useUser } from '../context/UserContext';

export const useRole = (role: RoleResponse | RoleResponse[]) => {
  const { details } = useUser();
  return _.includes(_.flatten([role]), details.role);
};
